/**
 * @file cookie-banner.component.ts
 * @description Presentational bottom-anchored cookie-consent banner.
 *
 * Host-agnostic: holds no consent state of its own. Consumers control
 * visibility via the `visible` input and react to user intent through
 * the `accepted` / `dismissed` outputs. The 24h re-open / persistence
 * logic lives in the consuming app (apps/kirigami-app/src/app/app.ts).
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { KirigamiButton } from '../kirigami-button/kirigami-button';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [KirigamiButton],
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieBannerComponent {
  /** Whether the banner is rendered. Owned by the consumer. */
  @Input() visible = false;

  /** Emitted when the user clicks "Accept all". */
  @Output() readonly accepted = new EventEmitter<void>();

  /** Emitted when the user dismisses the banner. */
  @Output() readonly dismissed = new EventEmitter<void>();
}
